// export const API_URL = 'https://window-world.herokuapp.com/api';
// export const BASE_URL = 'https://window-world.herokuapp.com';
// export const API_URL = 'http://localhost:8000/api';
// export const BASE_URL = 'http://localhost:8000';
// export const API_URL = 'http://192.168.8.220:8000/api';
export const API_URL = 'https://measureform.com/api';
export const BASE_URL = 'https://measureform.com';
